import AppBar from '@mui/material/AppBar';
import DialogActions from '@mui/material/DialogActions';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import DefaultButton from '../layout/DefaultButton';
import NativeDialog from "app/shared-components/layout/NativeDialog";
import ReferralDetailsPane from "app/shared-components/referral/ReferralDetailsPane";



function ReferralDetailsDialog({
                                   open,
                                   handleCloseDialog,
                                   referral,
                                   interest,
                                   enableActions,
                                   openDMDialog,
                                   openInterestDialog
                               }) {
  const dispatch = useDispatch();
  const { id, summary, organizationId } = referral ? referral : {};
  const title = 'Referral Details: ' + summary;

  function handleDiscard() {
	  handleCloseDialog();
  }

  return (

    <NativeDialog
        onClose={handleCloseDialog}
        open={open}
        width="100%"
        maxWidth="600px"
    >
      <AppBar position="static" color="secondary" elevation={0}>
	      <Toolbar className="flex w-full">
	        <Typography variant="subtitle1" color="inherit">
	          {title}
	        </Typography>
	      </Toolbar>
	  </AppBar>

        <ReferralDetailsPane
            referral={referral}
            interest={interest}
            enableActions={enableActions}
            openDMDialog={openDMDialog}
            openInterestDialog={openInterestDialog}
        />

          <DialogActions className="flex flex-col sm:flex-row sm:items-center justify-between py-16 sm:py-24 px-24">
            <div className="flex items-center space-x-8 mt-16 sm:mt-0">
              <DefaultButton text="Close" onClick={handleDiscard} />
            </div>
          </DialogActions>

    </NativeDialog>
  );
}

export default ReferralDetailsDialog;
